import React from 'react';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import EncodingDoc from '@splunk/dashboard-visualizations/common/EncodingDoc';
import EventsDoc from '@splunk/dashboard-visualizations/common/EventsDoc';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import DocExample from '@splunk/react-docs/DocExample';
import Rectangle from '@splunk/dashboard-visualizations/Rectangle';

import BasicExampleCode from '!!raw-loader!./examples/Basic';
import StrokeExampleCode from '!!raw-loader!./examples/Stroke';
import StrokeWidthExampleCode from '!!raw-loader!./examples/StrokeWidth';
import FillExampleCode from '!!raw-loader!./examples/Fill';
import FillOpacityExampleCode from '!!raw-loader!./examples/FillOpacity';
import StrokeDasharrayExampleCode from '!!raw-loader!./examples/StrokeDasharray';
import CornerRadiusExampleCode from '!!raw-loader!./examples/CornerRadius';
import StrokeLinejoinExampleCode from '!!raw-loader!./examples/StrokeLinejoin';
import StrokeFillEncodingCode from '!!raw-loader!./examples/StrokeFillEncoding';
import FillEncodingCode from '!!raw-loader!./examples/FillEncoding';
import StrokeEncodingCode from '!!raw-loader!./examples/StrokeEncoding';

import FillOpacityExample from './examples/FillOpacity';
import BasicExample from './examples/Basic';
import StrokeExample from './examples/Stroke';
import StrokeWidthExample from './examples/StrokeWidth';
import FillExample from './examples/Fill';
import StrokeDasharrayExample from './examples/StrokeDasharray';
import CornerRadiusExample from './examples/CornerRadius';
import StrokeLinejoinExample from './examples/StrokeLinejoin';
import StrokeFillEncodingExample from './examples/StrokeFillEncoding';
import FillEncodingExample from './examples/FillEncoding';
import StrokeEncodingExample from './examples/StrokeEncoding';

import doc from './definition';
import optionsSchema from '../optionsSchema';

function RectangleDoc() {
    return (
        <VisualizationDocPage
            title="Rectangle"
            examplesSection={[
                <DocExample
                    title="Basic Rectangle"
                    key="rectangle"
                    description="Default stroke, stroke width and fill"
                    code={BasicExampleCode}
                    example={BasicExample}
                />,
                <DocExample
                    title="Stroke Rectangle"
                    key="stroke_Rectangle"
                    description="Rectangle Stroke is red"
                    code={StrokeExampleCode}
                    example={StrokeExample}
                />,
                <DocExample
                    title="Stroke Width and Opacity Rectangle"
                    key="stroke_width_rectangle"
                    description="Rectangle Stroke Width is 5, Rectangle Stroke Opacity is 0.5"
                    code={StrokeWidthExampleCode}
                    example={StrokeWidthExample}
                />,
                <DocExample
                    title="Fill Rectangle"
                    key="fill_rectangle"
                    description="Rectangle Fill is blue"
                    code={FillExampleCode}
                    example={FillExample}
                />,
                <DocExample
                    title="Fill and Opacity Rectangle"
                    key="fillopacity"
                    description="Rectangle Fill is cyan, Rectangle Fill Opacity is 0.5"
                    code={FillOpacityExampleCode}
                    example={FillOpacityExample}
                />,
                <DocExample
                    title="Stroke Dash Array Rectangle"
                    key="stroke_dasharray_rectangle"
                    description="Rectangle Stroke Dash Array is 5"
                    code={StrokeDasharrayExampleCode}
                    example={StrokeDasharrayExample}
                />,
                <DocExample
                    title="Corner Radius Rectangle"
                    key="corner_radius_rectangle"
                    description="Rectangle Horizontal Corner Radius rx is 5, Rectangle Vertical Corner Radius ry is 5"
                    code={CornerRadiusExampleCode}
                    example={CornerRadiusExample}
                />,
                <DocExample
                    title="Stroke Line Join Rectangle"
                    key="stroke_linejoin_rectangle"
                    description="Rectangle Stroke Line Join is bevel"
                    code={StrokeLinejoinExampleCode}
                    example={StrokeLinejoinExample}
                />,
                <DocExample
                    title="Fill and Stroke Encoding"
                    key="strokefillencoding"
                    description="Fill Encoding is blue, Stroke Encoding is purple"
                    code={StrokeFillEncodingCode}
                    example={StrokeFillEncodingExample}
                />,
                <DocExample
                    title="Fill Encoding"
                    key="fill_encoding"
                    description="Fill Encoding is blue"
                    code={FillEncodingCode}
                    example={FillEncodingExample}
                />,
                <DocExample
                    title="Stroke Encoding"
                    key="stroke_encoding"
                    description="Stroke Encoding is purple"
                    code={StrokeEncodingCode}
                    example={StrokeEncodingExample}
                />,
            ]}
            encodingSection={<EncodingDoc encoding={doc.encoding} />}
            optionSection={<OptionsDoc options={optionsSchema} />}
            eventSection={
                <EventsDoc
                    options={{}}
                    events={doc.events}
                    Visualization={Rectangle}
                    encoding={{}}
                    dsState={{
                        primary: {
                            data: {
                                columns: [
                                    ['1', '62', '103', '308', '587', '876', '930', '1320'],
                                    [
                                        '#FF0000',
                                        '#00FFFF',
                                        '#0000FF',
                                        '#800080',
                                        '#FFFF00',
                                        '#FFA500',
                                        '#A52A2A',
                                        '#008000',
                                    ],
                                ],
                                fields: [
                                    {
                                        name: 'count',
                                    },
                                    {
                                        name: 'color',
                                    },
                                ],
                            },
                            meta: {},
                        },
                    }}
                />
            }
        />
    );
}

export default RectangleDoc;
